import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

class DismissableAlert extends Component {
  constructor(props) {
    super(props);

    this.state = {
      visible: props.children != null && props.children !== ''
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      nextProps.children !== this.props.children &&
      nextProps.children != null &&
      nextProps.children !== ''
    ) {
      this.setState({
        visible: true
      });
    } else if (
      this.state.visible === true &&
      (nextProps.children == null ||
        nextProps.children === '' ||
        nextProps.children.length < 1)
    ) {
      this.setState({
        visible: false
      });
    }
  }

  render() {
    const { className, dismiss, children } = this.props;

    const dismissFunction =
      dismiss ||
      (() => {
        this.setState({
          visible: false
        });
      });

    return this.state.visible ? (
      <div
        className={classNames({
          'invert alert-wrapper active': true,
          [className]: true
        })}
      >
        <div className="alert-content">
          {typeof children === 'string' ? (
            <p dangerouslySetInnerHTML={{ __html: children }} />
          ) : (
            <p>{children}</p>
          )}
        </div>
        <div
          className="alert-close close-button"
          onClick={e => {
            e.stopPropagation();
            e.preventDefault();
            dismissFunction();
            return false;
          }}
        >
          <span
            className="icon icon-close"
            data-placement="top"
            data-toggle="tooltip"
            title=""
            data-original-title="Close Alert"
          />
        </div>
      </div>
    ) : null;
  }
}

DismissableAlert.propTypes = {
  className: PropTypes.string,
  dismiss: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ])
};

export default DismissableAlert;
